import React from 'react'
import { InboxOutlined } from '@ant-design/icons'
import { message, Upload } from "antd"

import { storeResultAttachment } from '../services'
import { handleError } from '../../../helpers'

const { Dragger } = Upload

export default function ResultAttachmentForm({ serviceResultId, reload }) {

    const props = {
        multiple: true,
        customRequest: async ({ file, onError, onSuccess: handleSuccess }) => {
            const fileExt = file.name.split('.').pop().toLowerCase()

            const values = new FormData()
            const fileName = `${Date.now()}${Math.floor(1000 + Math.random() * 9000)}.${fileExt}`
            values.append('file', file)
            values.append('file_path', `app/service_results/${serviceResultId}/${fileName}`)
            values.append('service_result_id', serviceResultId)

            try {
                const response = await storeResultAttachment(values)
                handleSuccess(response.data, file)
                message.success(response.data.message)
                reload()
            } catch (error) {
                handleError(error)
                onError(error)
                console.error('Error al subir el archivo: ', error.message)
            }
        }
    };

    return (
        <div style={{ maxWidth: '400px', margin: 'auto' }}>
            <Dragger {...props} className="px-10">
                <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: '#e78035', fontSize: '41px' }} />
                </p>
                <p className="ant-upload-text">
                    Haga clic o arrastre el o los adjuntos aquí
                </p>
                <p className="ant-upload-hint">
                    Solo se permite adjuntar uno o más archivos menores a 5MB.
                </p>
            </Dragger>
        </div>
    )
}
